import Chip from '@material-ui/core/Chip';
import PropTypes from 'prop-types';
import React from 'react';


class ChipSelectMultiple extends React.Component {

    static propTypes = {
        handleChange: PropTypes.func.isRequired,
        classes: PropTypes.shape({
            root: PropTypes.string,
            clickable: PropTypes.string,
            deletable: PropTypes.string,
            avatar: PropTypes.string,
            avatarChildren: PropTypes.string,
            label: PropTypes.string,
            deleteIcon: PropTypes.string,
        }),
        disabled: PropTypes.bool,
        className: PropTypes.string,
        chipClassName: PropTypes.string,
        activeClassName: PropTypes.string,
        disabledClassName: PropTypes.string,
        data: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
            label: PropTypes.node.isRequired,
        })).isRequired,
    };

    static defaultProps = {
        // CSS overrides of material ui chip
        // @see https://material-ui.com/api/chip/
        classes: {},
        className: 'schnoffle-chip-container',
        chipClassName: 'schnoffle-chip-default',
        activeClassName: 'schnoffle-chip-selected',
        disabledClassName: 'schnoffle-chip-disabled',
        disabled: 0,
    };

    constructor(props) {
        super(props);
        this.state = {
            activeChips:
                this.props.activeChips
                    ? this.props.activeChips
                    : new Set(),
        };
    }

    handleChange = event => {
        const selectedChipID = event.target.parentElement.dataset.chipvalue;

        if (!selectedChipID) {
            // Sometimes during testing we get an undefined selectedChipID
            // here.
            // This breaks fatal, as one of the Chipvalues is undefined. Seems
            // an async setState / rerender issue. Therefore we try to set the
            // current state again.
            console.log({
                selectedChipID,
                event,
                eventTarget: event.target.parentElement,
                state: this.state,
                props: this.props,
            });
        }

        if (this.state.activeChips.has(selectedChipID) &&
        this.state.activeChips.size > 1) {
            this.state.activeChips.delete(selectedChipID);
            this.setState(Object.assign(
                {},
                this.state,
            ));
        }
        else {
            if (selectedChipID !== undefined) {
                this.state.activeChips.add(selectedChipID);
            }
            this.setState(Object.assign(
                {},
                this.state,
            ));
        }
        this.props.handleChange(this.state.activeChips);
    };

    buildChips = () => {
        var Chips = this.props.data.map(chipdata => {
            const isSelected = this.state.activeChips.has(chipdata.value);
            var activeClass = isSelected
                ? ` ${this.props.activeClassName}`
                : '';
            activeClass = this.props.disabled ?
                ` ${this.props.disabledClassName}`
                : activeClass;
            const classNames = `${this.props.chipClassName} ${activeClass}`;
            return (
                <Chip
                    key={chipdata.value}
                    data-chipvalue={chipdata.value}
                    label={chipdata.label}
                    clickable={!this.props.disabled}
                    onClick={this.props.disabled ? null : this.handleChange}
                    classes={Object.assign(
                        {},
                        { root: classNames },
                        this.props.classes,
                    )}
                    className={classNames}
                />
            );
        });
        return Chips;
    };

    render() {
        return (
            <div className={this.props.className}>
                {this.buildChips()}
            </div>
        );
    }

}


export default ChipSelectMultiple;



// WEBPACK FOOTER //
// ./src/components/common/ChipSelectMultiple.js